RivalIQ.apps.SocialPosts.module('mixins', function (mixins, App, Backbone, Marionette, $, _, s) {

    'use strict';

    mixins.LinksTableWidgetCsv = {
        getExportMetricDefinitions: function (format) {
            const me = this;
            let metrics = me.metricsCollection.invoke('serialize', format);
            metrics[0].property = 'name';

            const sortAttrPrefix = _.head(me.metricsCollection.at(0).getFreeDimensions());
            let sortProps;
            if (_.includes(['primaryDomain', 'canonicalUrl'], sortAttrPrefix)) {
                sortProps = _.reduce(['sortOrder', 'orderBy'], function (memo, attrName) {
                    memo[sortAttrPrefix + _.upperFirst(attrName)] = metrics[0][attrName];
                    return memo;
                }, {});
                sortProps[`${sortAttrPrefix}Limit`] = -1;
            }

            metrics = metrics.concat([
                _.defaults({
                    property: 'engagement_total'
                }, metrics[1]),
                _.defaults({
                    property: 'presence_reach'
                }, metrics[1])
            ]);

            return _.map(metrics, function (metric) {
                return _.extend(metric, sortProps);
            });
        }
    };

    function addFilter(props, dimension, filterValue) {
        // If the dimension is canonicalUrl, we want to do an exact match; canonicalUrlFilter will do
        // a prefix match, which can result in inconsistencies in the UI. See #18405.
        const filterName = (dimension === 'canonicalUrl' ? 'canonicalUrlExactMatch' : `${dimension}Filter`);
        props[filterName] = filterValue;
    }

    mixins.LinksPostedTableMixin = {
        rowClassName: 'pointer',

        onRowClick: function (data, e, dimensionRow) {
            const me = this;

            const target = $(e.target);
            const hasHref = !_.isEmpty(target.attr('href'));

            const selection = window.getSelection && window.getSelection();
            if (selection && selection.toString().length > 0) {
                return;
            }

            // need the parents selector as sometimes the target is the font-awesome icon.
            if (data && !hasHref &&
                !target.hasClass('table-expander') && target.parents('.table-expander').length === 0 &&
                !target.hasClass('subordinate-row-view-more') && target.parents('.subordinate-row-view-more').length === 0) {
                const source = RivalIQ.data.channels.get(me.getProp('channel')).get('source');

                const props = me.dashboardModel.getProps();

                const baseMetric = me.metric || me.dashboardModel.getBaseMetric();
                const freeDimensions = baseMetric.getFreeDimensions();
                let company;

                if (_.includes(freeDimensions, 'companyId')) {
                    const companyId = data[0][0];
                    company = RivalIQ.state.landscape.getCompanyById(companyId).toJSON();
                    props.modalTitle = `Posts by ${company.name}`;
                } else if (freeDimensions.length === 1) { // This should always be the case, but doesn't hurt to check.
                    addFilter(props, _.head(freeDimensions), data[0][0]);
                    props.modalTitle = `Posts with ${data[0][0]}`;
                }

                if (dimensionRow && props.dimension) {
                    addFilter(props, props.dimension, dimensionRow[0][1]);
                    props.modalTitle = `Posts with ${dimensionRow[0][1]}`;
                }

                // domainsOnly mode calculates some aggregates we don't need, set it to false.
                props.domainsOnly = false;
                props.excludePostsWithoutLinks = true;
                props.includeDimensionResults = false;
                props.includeObservations = false;
                delete props.dimension;

                RivalIQ.apps.SocialPosts.views.PostsModal.show(props, source, company);

                e.preventDefault();

                const isSubordinateRow = target.parents('.subordinate-row').length > 0;

                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.PostedURLsViewPosts, {
                    channel: props.channel,
                    widgetId: me.dashboardModel.get('id'),
                    isSubordinateRow: isSubordinateRow
                });
            }
        }
    };
});
